import { Pipe, PipeTransform } from '@angular/core';
import { isString } from '@skylab-shared/utils';

interface IDateObj {
    month: string;
    day: string;
    year: string;
}

@Pipe({ name: 'skl-raw-date' })
export class RawDatePipe implements PipeTransform {
    private readonly monthsNamePattern: RegExp[] = [
        /stycz(eń|nia)/,
        /lut(y|ego)/,
        /mar(zec|ca)/,
        /kwie(tnia|cień)/,
        /maja?/,
        /czerw(ca|iec)/,
        /lip(ca|iec)/,
        /sierp(nia|ień)/,
        /wrze(sień|śnia)/,
        /października?/,
        /listopada?/,
        /grud(nia|zień)/,
    ];
    private monthsPattern = /^(0?[1-9]|1[012])$/;
    private readonly daysPattern: RegExp = /^((([1-9])|(0[1-9])|([12])([0-9]?)|(3[01]?))|(([1-9])|(0[1-9])|([12])([0-9]?)|(3[0]?)))$/;
    private readonly yearPattern: RegExp = /^\d{4}$/;

    public transform(value: string | Date): Date {
        if (value === '') return new Date();
        return isString(value) ? new Date(this.dateFromText(value)) : new Date(value);
    }

    private dateFromText(value: string): number {
        const [day, month, year] = this.predictPattern(this.splitValue(value));
        return Date.parse(`${year}/${month}/${day}`);
    }

    private splitValue(value: string): string[] {
        return value.split(/[\s,-./]+/);
    }

    private predictPattern(bits: string[]): number[] {
        let bitsMap: (string | null)[] = bits;
        const day = this.day(bitsMap);
        bitsMap = bits.map(value => `${day}` !== value ? value : null);
        const month = this.month(bitsMap);
        bitsMap = bits.map(value => `${month}` !== value ? value : null);
        const year = this.year(bitsMap);
        return [day, month, year];
    }

    private findMatch(bits: (string | null)[], testPattern: RegExp): string | null {
        return bits.map(value => testPattern.test(value!) ? value : null).filter(Boolean)[0];
    }

    private day(bits: (string | null)[]): number {
        let result = Number(this.findMatch(bits, this.daysPattern));
        if (!result) {
            result = new Date().getMonth();
        }
        return result;
    }

    private month(bits: (string | null)[]): number {
        let result = bits.map(value => this.monthsNamePattern.findIndex(rx => rx.test(value!)) + 1).filter(Boolean)[0] ||
        Number(this.findMatch(bits, this.monthsPattern));
        if (!result) {
            result = new Date().getMonth();
        }
        return result;
    }

    private year(bits: (string | null)[]): number {
        let result = Number(this.findMatch(bits, this.yearPattern));
        if (!result) {
            result = new Date().getFullYear();
        }
        return result;
    }
}
